/*
  Generates UI chart to compare all rate scheduled within a collection.
  Need to iterate over each rate schedule:
    For the left most column which lists all features found in all rate schedules:
      create a unique list of features and additional charges, sort each alphabetically
    Generate a vertical column for each rate schedule ordered by ordinal:
      indicate which features and amounts for each feature
*/
import {RateSchedule} from 'admin/accounting/rate_schedule'

export default class RateScheduleCollectionCompare extends HTMLElement {
  constructor(groupId) {
    super();
    this.groupdId = groupId
  }

  async connectedCallback() {

    this.innerHTML = `
      <style>

      h2 {
        margin-bottom: 8px;
        font-size: 26px;
        font-weight: 400;
      }

      .plan_table {
        padding: 16px 8px 20px 12px;
      }

      @media only screen and (min-width: 1280px) {
        .plan_table {
          padding: 16px 8px 20px 32px
        }
      }

      </style>

      <div class="row">
        <template id="additional_charges_template">      
          <div class="content">
          <h2>Compare Plans</h2>
            <table class="pricing-table" style="width:100%">
              <colgroup>
                <col class="col-headers" />
              </colgroup>
              <thead>
                <tr>
                  <td class="info">
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        </template>
          
        <div class="form-group form-horizontal plan_table col-xs-12" style="padding: 20px">
          <div class="col-sm-12 no-gutters" id="comparisons">



          </div>
        </div>   
      </div> 
    `


  }

 // Only used by the rate-schedule-collections-menu component when selecting
  // a collection. Load the rate schedules in the collection to be rendered.
  async loadCollection(rate_schedule_collection_id) {
    if (rate_schedule_collection_id === null) {
      this.data = []
    }
    else {
      let url = `/admin/rate_schedule_groups/${rate_schedule_collection_id}/rate_schedules`
      let res = await fetch(url);
      const rate_schedules = await res.json();
      this.data = rate_schedules
      // console.log('comparator loadCollection data: ',this.data)
    }

    this.renderRateScheduleCards()
  }

  renderRateScheduleCards() {
    if (this.data.length > 0) {
      // this should generate a default skeleton for the compare ui
      this.rateSchedules = []
      this.data.map(rate_schedule => {
        this.rateSchedules.push(new RateSchedule(rate_schedule))
      })
      // this.rateSchedule = this.rateSchedules[0]
      this.populate_inner_html_template()
    }  
    else {
      const compare_container = this.querySelector('#comparisons');
      if (compare_container) {
        compare_container.innerHTML = ''
      }
    }
  }


  populate_inner_html_template() {
    // this is used to generate the left most list of included features
    this.included_features = []
    this.rateSchedules.map(rs => {
      rs.included_items().map(charge => {
        this.included_features.push({billing_charge_id: charge.data.billing_charge_id, description: charge.data.description})
      })
    })

    this.included_features = [...new Map(this.included_features.map((item) => [item.billing_charge_id, item])).values()];

    this.included_features.sort(function (a, b) {
      if ( a.description < b.description ){
        return -1;
      }
      if ( a.description > b.description ){
        return 1;
      }
      return 0;    
    });
    // console.log('included_features',this.included_features)


    // this is used to generate the left most list of additional charges
    this.additional_charges = []
    this.rateSchedules.map(rs => {
      rs.additional_items().map(charge => {
        this.additional_charges.push({billing_charge_id: charge.data.billing_charge_id, description: charge.data.description})
      })
    })
    // only unique items
    this.additional_charges = [...new Map(this.additional_charges.map((item) => [item.billing_charge_id, item])).values()];
    this.additional_charges.sort(function (a, b) {
      if ( a.description < b.description ){
        return -1;
      }
      if ( a.description > b.description ){
        return 1;
      }
      return 0;
    });
    // console.log('additional_charges',this.additional_charges)



    const template = this.generate_additional_charges_template();
    const compare_container = this.querySelector('#comparisons');
    if (compare_container) {
      compare_container.innerHTML = template
    }

  }   

  // used to shorten commonly used longer declaration to get at RateSchedule data
  rs(){
    return this.rateSchedules[0].data
  }


  generate_additional_charges_template() {
    let modal_content = [];
    if (this.rs().rate_schedule_charges_attributes) {
      modal_content = this.generate_modal_template();
    }

    let html = `
        <div id="modal_template_container">
          ${modal_content}
        </div>
    `

    return html;
  }

  generate_modal_template() {
    let html = '';
    // this template currently resides in the BillingPlan object.
    const templateEl = this.querySelector('#additional_charges_template');
    if (! templateEl){
      return html;
    }
    const template = templateEl.content.cloneNode(true)

    this.render_included_usage(template)
    this.render_additional_usage(template)

    // render extra columns for each rate schedule
    const table = template.querySelector('.pricing-table')
    if (table) {
      const colgroup = table.querySelector('colgroup')
      const thead_tr = table.querySelector('thead tr')
      const included_features_body = table.querySelector('tbody#included_features')
      const included_features = table.querySelector('tbody#included_features tr')
      const additional_charges = table.querySelector('tbody#additional_charges tr')
      const additional_charges_body = table.querySelector('tbody#additional_charges')

      this.rateSchedules.map(rs => {
        // create extra col-data columns
        const col = document.createElement("col")
        col.classList.add("col-data")
        colgroup.appendChild(col)


        // create extra thead columns
        let el = document.createElement("th")
        el.classList.add("title")
        el.textContent = rs.data.rate_schedule_name
        el.setAttribute("scope","col")
        thead_tr.appendChild(el)    
      })




      // add included features
      this.included_features.map(feature => {
        // console.log('included feature', feature)
        // create the tr element to hold the description
        const tr = document.createElement('tr')
        tr.classList.add("feature")
          const th = document.createElement('th')
          th.setAttribute('scope','row')
          th.innerText = feature.description
          tr.appendChild(th)

          // add a column for each rate schedule related to this feature
          this.rateSchedules.map(rs => {

            // find a matching billable charge
            const matching_feature = rs.charges.find(charge => {
              return feature.billing_charge_id === charge.data.billing_charge_id
            })

            if (matching_feature){
              const td = document.createElement('td')
              td.setAttribute('colspan','1')
              td.classList.add('right-sep')
              const v = matching_feature.get_formatted_included_amount()
              if (v > 0) {
                td.innerText = v
              }
              tr.appendChild(td)
            }
            else {
              const td = document.createElement('td')
              td.setAttribute('colspan','1')
              td.classList.add('right-sep')
              td.innerText = ""
              tr.appendChild(td)
            }
          })

      included_features_body.appendChild(tr)         
      })




      // show additional charges
      this.additional_charges.map(feature => {
        // create the tr element to hold the description
        const tr = document.createElement('tr')
        tr.classList.add("feature")
          const th = document.createElement('th')
          th.setAttribute('scope','row')
          th.innerText = feature.description
          tr.appendChild(th)

          // add a column for each rate schedule related to this additional charge
          this.rateSchedules.map(rs => {

            // find a matching billable charge
            const matching_feature = rs.charges.find(charge => {
              return feature.billing_charge_id === charge.data.billing_charge_id
            })

            if (matching_feature){
              const td = document.createElement('td')
              td.setAttribute('colspan','1')
              td.classList.add('right-sep')
              const v = matching_feature.get_additional_usage_price()
              if (v > 0) {
                td.innerText = `${numeral( v ).format('$0,0.00[00]')} each`;
              }
              tr.appendChild(td)
            }
            else {
              const td = document.createElement('td')
              td.setAttribute('colspan','1')
              td.classList.add('right-sep')
              td.innerText = ""
              tr.appendChild(td)
            }
          })

      additional_charges_body.appendChild(tr)         
      })      
    }

    var outer= document.createElement('div');
    outer.appendChild(template);
    return outer.innerHTML;
  }

  render_included_usage(template) {
    const tbody = document.createElement('tbody')
    tbody.setAttribute("id","included_features")

    // create the Included Usage title row if there are charges
    let tr = document.createElement('tr')
      let td = document.createElement('td')
      td.innerText = "Included Usage"
      td.setAttribute("colspan",1 + this.rateSchedules.length)
      td.classList.add("category")
    tr.appendChild(td)
    tbody.appendChild(tr)

    const thead = template.querySelector('.pricing-table thead')
    const tbodyz = template.querySelector('.pricing-table tbody:last-child')
    let parent = tbodyz || thead
    parent.after(tbody)
  }

  render_additional_usage(template) {
    const tbody = document.createElement('tbody')
    tbody.setAttribute("id","additional_charges")

    // create the Included Usage title row if there are charges
    let tr = document.createElement('tr')
      let td = document.createElement('td')
      td.innerText = "Additional Usage"
      td.classList.add("category")
      td.setAttribute("colspan",1 + this.rateSchedules.length)
    tr.appendChild(td)
    tbody.appendChild(tr)

    const thead = template.querySelector('.pricing-table thead')
    const tbodyz = template.querySelector('.pricing-table tbody:last-child')
    let parent = tbodyz || thead
    parent.after(tbody)

    const footer = document.createElement('tfoot')
    tr = document.createElement('tr')
      td = document.createElement('td')
      td.setAttribute("colspan",1 + this.rateSchedules.length)
      td.classList.add("regulatory_text")
      td.innerHTML =`
                    <span>
                      * Canadian Local Numbers are $3 per number <br/>
                      ** Federal and Regulatory Fees may apply  
                    </span>      
      `
    tr.appendChild(td)
    footer.appendChild(tr)
    parent.after(footer)

  }
}
customElements.define("rate-schedule-collection-compare", RateScheduleCollectionCompare);

